exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 1rem; }\n\n.centerButton {\n  margin: 0 auto; }\n\n.table-spacer {\n  height: 1px;\n  margin: 0 1rem;\n  border-bottom: 1px dotted black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/admin/containers/admin/admin.component.scss
// module id = ../../../../../src/app/admin/containers/admin/admin.component.scss
// module chunks = main